import { useProperty } from '../../hooks/context/context.hook'
import { Navigate } from 'react-router-dom'

export default function RequiredProperty({ children }: { children: JSX.Element }) {
  const property = useProperty();
  if (!property) return <Navigate to="/" />
  return children
}